module.exports = __webpack_public_path__ + "img/pingjia.075047d7.jpg";